import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=1412a96f&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=1412a96f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1412a96f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1412a96f')) {
      api.createRecord('1412a96f', component.options)
    } else {
      api.reload('1412a96f', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=1412a96f&scoped=true&", function () {
      api.rerender('1412a96f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dFRg0UPcBT96/JS/comp/PopupDialog.vue"
export default component.exports